/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'
import {
  BrowserRouter as Router,
  useHistory
} from 'react-router-dom'
import { Form, Input, Button, Card, Layout } from 'antd'
import 'antd/dist/antd.css'
import './Login.scss'
import ButtonMain from '../../components/ButtonMain/ButtonMain.jsx'
import logo from '../../assets/images/Frame 20.png'
import customerService from '../../assets/images/customerService.png'
import forgetPassword from '../../assets/images/forgetPassword.png'
import member from '../../assets/images/member.png'
import ErrorHandler from '../../utils/ErrorHandler'
import { LoginApiHandler, CompareECMember, GetAuthorize } from '../../api/Login/index'
import ConfirmHandler from '../../utils/ConfirmHandler'
import Loading from '../../components/Loading/Loading.jsx'
import { getExpirationAt } from '../../apiFunction/getDate'
import moment from 'moment'

const { Header } = Layout

export default function Login () {
  const [form] = Form.useForm()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false)
  const [confirmModalMsg, setConfirmModalMsg] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  useEffect(() => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const rurl = urlParams.get('rurl')
    const preRurl = sessionStorage.getItem('rurl')
    if (!preRurl) {
      sessionStorage.setItem('rurl', rurl)
    }
    const memberAccessToken = localStorage.getItem('member_access_token')
    const ttl = localStorage.getItem('ttl')
    if (memberAccessToken && ttl) {
      const isExpired = moment().isAfter(ttl)
      if (!isExpired) {
        fetchDataToAuthorizePage(memberAccessToken)
      } else {
        localStorage.clear()
      }
    }
  }, [])
  let goToRegister = false
  const compareMember = async (memberAccessToken, phone) => {
    const compareECmemberResp = await CompareECMember({ memberAccessToken: memberAccessToken, phone: phone })
    const { rcrm, results } = compareECmemberResp
    if (rcrm.RC !== 'C01') {
      setIsLoading(false)
    } else if (rcrm.RC !== 'LOGIN_MULTIPLE_TIMES_ERROR') {
      // 登入失敗過多次，只顯示 API 錯誤訊息
      setIsLoading(false)
    } else {
      setIsLoading(false)
      const { is_mmrm_member, status } = results
      if (is_mmrm_member) {
        setIsModalVisible(true)
        setConfirmModalMsg('系統升級整合，將轉至會員頁面，請重新註冊登入。')
        goToRegister = true
      } else {
        if (status) {
          setIsModalVisible(true)
          setConfirmModalMsg('登入失敗，請重新登入。')
        }
        setIsModalVisible(true)
        setConfirmModalMsg('請使用棉花田APP會員帳號登入。')
      }
    }
  }
  const handleOk = () => {
    setIsModalVisible(false)
    if (goToRegister) {
      goToRegisterPage()
    }
    goToRegister = false
  }

  const goToRegisterPage = () => {
    history.push('/register')
  }

  const fetchDataToAuthorizePage = async (memberAccessToken) => {
    setIsLoading(true)
    const resp = await GetAuthorize(memberAccessToken)
    if (resp) {
      if (resp.rcrm.RC === 'C01') {
        setIsLoading(false)
        location.replace(`${resp.results.location}`)
      } else {
        setIsModalVisible(true)
        setConfirmModalMsg(`${resp.rcrm.RM}`)
      }
    }
  }

  const saveMemberAccessToken = (token) => {
    if (process.env.REACT_APP_CREDENTIAL_EXPIRE_AMOUNT && process.env.REACT_APP_CREDENTIAL_EXPIRE_UNIT) {
      localStorage.setItem('member_access_token', token)
      localStorage.setItem('ttl', getExpirationAt())
    } else {
      sessionStorage.setItem('member_access_token', token)
    }
  }

  const onFinish = async () => {
    form.validateFields()
      .then(async (values) => {
        setIsErrorModalVisible(false)
        setIsLoading(true)
        const resp = await LoginApiHandler({ account: values.account, password: values.password })
        if (resp) {
          const { rcrm, results } = resp
          if (rcrm.RC === 'C01') {
            saveMemberAccessToken(results.member_access_token)
            fetchDataToAuthorizePage(results.member_access_token)
            return
          } else if (rcrm.RC !== 'MEMBER_IS_NOT_EXIST') {
            setIsModalVisible(true)
            setConfirmModalMsg(rcrm.RM)
          }

          compareMember(results.member_access_token, values.account)
        }
      })
      .catch(error => {
        const { errorFields } = error
        const filterErrorMsg = errorFields.map(item => {
          const { errors } = item
          item.errors = [...new Set(errors)]
          return item
        })
        setIsErrorModalVisible(filterErrorMsg)
      })
  }

  return (
    <div>
      <Card type="inner" className="loginPage-basic">
        <Header>
          <img src={logo} />
        </Header>
        {isErrorModalVisible ? <ErrorHandler errorList={isErrorModalVisible} /> : null}
        <Form
          name="basic"
          autoComplete="off"
          form={form}
          validateTrigger='onSubmit'
        >
          <Form.Item
            label="手機"
            name="account"
            rules={[
              {
                required: true,
                message: '手機為必填'
              },
              {
                len: 10,
                message: '手機格式錯誤'
              }
            ]}
          >
            <Input className="input-text" placeholder="請輸入您的會員手機號碼" />
          </Form.Item>
          <Form.Item
            label="密碼"
            name="password"
            rules={[
              {
                required: true,
                message: '密碼為必填'
              },
              {
                min: 6,
                message: '密碼須為 6-12 碼英數字混合'
              },
              {
                max: 12,
                message: '密碼須為 6-12 碼英數字混合'
              },
              {
                pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
                message: '密碼須為 6-12 英數字混合'
              }
            ]}
          >
            <Input.Password className="input-text" placeholder="6 - 12 碼英數字混和" />
          </Form.Item>
          <ButtonMain buttonType="main" onClick={onFinish}>會員登入</ButtonMain>
        </Form>
      </Card>
      <Card
        type="inner"
        className="container-link"
      >
        <Router>
          <Button type="link" className="button-link" onClick={() => { history.push('/forgetPassword') }}>
            <img src={forgetPassword} />
            <span>忘記密碼</span>
          </Button>
          <Button type="link" className="button-link" onClick={goToRegisterPage}>
            <img src={member} />
            <span>註冊會員</span>
          </Button>
          <Button type="link" className="button-link" onClick={() => { window.open('https://www.healthyfood.com.tw/contact', '_blank') }}>
              <img src={customerService} />
              <span>聯繫客服</span>
          </Button>
        </Router>

      </Card>
      <Loading isLoadingVisible={isLoading}></Loading>
      {isModalVisible ? <ConfirmHandler title="提示" setModalvisible={isModalVisible} setHandleOk={handleOk} msg={confirmModalMsg} /> : null}
    </div>
  )
}
